import { ILabels } from '@bloomays-lib/types.shared';
import omit from 'lodash/omit';
import uniq from 'lodash/uniq';
import flatMap from 'lodash/flatMap';

type ILabelEditable<T extends ILabels> = T & {
  isNew?: boolean;
  merge?: string;
};

export const cleanEditableLabelBeforeUpdate = <T extends ILabels>(row: ILabelEditable<T>): T => {
  let alt = row.alternateLabels as unknown as string[] | string | undefined;
  if (alt) {
    if (!Array.isArray(alt)) {
      const alts = alt.split ? alt.split(',') : [];
      alt = alts.filter((l) => {
        return !!l && l !== '';
      });
    } else {
      // avoid readlony object
      alt = [...row.alternateLabels];
    }
    alt = uniq(flatMap(alt, (a) => a.split('\n')));
    return omit({ ...row, alternateLabels: alt }, ['merge', 'isNew']) as unknown as T;
  }
  return omit({ ...row }, ['merge', 'isNew']) as unknown as T;
};

export const cleanEditableLabelBeforeCreate = <T extends ILabels>(row: ILabelEditable<T>): T => {
  const cleanRow = cleanEditableLabelBeforeUpdate(row);
  return omit(cleanRow, ['merge', 'isNew', 'id']) as unknown as T;
};
